import { render, staticRenderFns } from "./laporan_tunggakan_perkecamatan.vue?vue&type=template&id=c52f12ea&"
import script from "./laporan_tunggakan_perkecamatan.vue?vue&type=script&lang=js&"
export * from "./laporan_tunggakan_perkecamatan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports